import {Module, VuexModule, Mutation, Action, getModule} from 'vuex-module-decorators'
import store from '../index'
import {getMessageCount} from '@/api/message'
import Vue from 'vue'

@Module({
    name: 'message',
    // namespaced: true,
    store,
    dynamic: true
})
export default class MessageStore extends VuexModule {
    remindNum = 0 // 提醒上的标记是否显示
    reviewNum = 0 // 待审批数量
    noticeNum = 0 // 未读通知数量
    reviewUserNum = 0 //审批未读审批数量
    remindBadgeShow = false
    socket = null
    resData = {}
    msgList = {
        Notice: [],
        remind: [],
        messageReviewCc: [],
        messageReviewUser: []
    }


    get remindBadge() {
        let bol = false
        if (this.remindNum > 0 || this.remindBadgeShow) {
            bol = true
        }
        // console.log('bol,',bol)
        return bol
    }

    get messageBadge() {
        let bol = false
        if ((this.reviewNum + this.remindNum + this.noticeNum + this.reviewUserNum + this.reviewUserNum > 0) || this.remindBadgeShow) {
            bol = true
        }
        return bol
    }

    @Mutation
    MESSAHE_NUM(data: { messageNoticeCount: number; messageRemindCount: number; messageReviewCount: number;messageReviewUserCount:number }) {
        const {messageNoticeCount, messageRemindCount, messageReviewCount,messageReviewUserCount} = data
        this.remindNum = messageRemindCount
        this.reviewNum = messageReviewCount
        this.noticeNum = messageNoticeCount
        this.reviewUserNum = messageReviewUserCount
    }

    @Mutation
    SET_REMIND_BADGE(bol: boolean) {
        // console.log('this.remindBadgeShow--------',this.remindBadgeShow)
        this.remindBadgeShow = bol
    }

    @Mutation
    MSGNOTICE_NUM(data: { types: string; message: string }) {
        this.resData = data
    }

    @Mutation
    GETMSGLIST(data) {
        if (data.types === 'remind') {
            this.msgList['remind'].push(data)
        } else if (data.types === 'messageReviewUser') {
            this.msgList['messageReviewUser'].push(data)
        } else if (data.types === 'messageReviewCc') {
            this.msgList['messageReviewCc'].push(data)
        } else if (data.type === "Notice") {
            this.msgList['Notice'].push(data)
        }
    }

    @Mutation
    GETNEWMSGLIST(data) {
        this.msgList = data
    }

    @Mutation
    DELETE_MESG_ITEM(name) {
        this.msgList[name] = []
    }

    @Action
    async getMessageCount() {
        const data: any = await getMessageCount()
        this.MESSAHE_NUM(data)
    }

    @Action
    async getMsgNoticeCount(res) {
        this.MSGNOTICE_NUM(res)
    }

}

export const MessageModule = getModule(MessageStore)
